import { WIDGET_EVENTS, WIDGET_EVENT_PREFIX } from './constants';
import qs from 'query-string';
import { v4 as uuid } from 'uuid';

const queryString = qs.parse(location.search);
const id = queryString.id;

class TrackingService {
  /**
   * @typedef {Object} TrackingData
   * @property {string} [distributionContainerId]
   * @property {string} [distributionPageId]
   * @property {string} eventType
   * @property {boolean} isLive
   * @property {boolean} isPlaying
   * @property {string} orgId
   * @property {string} [playerAppInstanceId]
   * @property {string} [playerInstanceId]
   * @property {number} playerVersion
   * @property {string} showId
   * @property {string} sourceApp
   * @property {number} videoCurrentTime
   */

  /**
   * Tracking point with "data"
   * @param {TrackingData} data
   */
  track(data) {
    let combinedData = data || {};
    if (this.testingData) {
      combinedData = {
        ...data,
        ...this.testingData,
      };
    }

    const eventPayload = JSON.stringify({
      eventName: `${WIDGET_EVENT_PREFIX}${WIDGET_EVENTS.TRACKING}`,
      data: {
        id,
        schemaVersion: '2.1.0',
        source: 'player',
        insertId: uuid(),
        clientTimestamp: new Date().toISOString(),
        distributionContainerId: data.distributionContainerId || null,
        distributionPageId: data.distributionPageId || null,
        playerAppInstanceId: data.playerAppInstanceId || null,
        playerInstanceId: data.playerInstanceId || null,
        playerVersion: data.playerVersion || 2,
        payload: combinedData, // To comply with schemaVersion: '2.1.0', while keeping the data intact
        ...combinedData,
      },
    });
    window.parent.postMessage(eventPayload, '*');
  }

  /**
   * Helper method to build an event type used for tracking with this format module:action:[meta]
   * @param {string} module
   * @param {string} action
   * @param {string} [meta]
   * @returns {string} module:action:[meta]
   */
  buildTrackingEventName(module, action, meta) {
    let eventType = `${module}:${action}`;
    if (meta) {
      eventType += `:${meta}`;
    }
    return eventType;
  }

  getModule(isCondensed, playerTimeout) {
    if (isCondensed) {
      return WIDGET_EVENTS.MODULE.CONDENSED;
    } else if (playerTimeout === null) {
      return WIDGET_EVENTS.MODULE.PREVIEW_PAUSED;
    }
    return WIDGET_EVENTS.MODULE.PREVIEW_PLAYING;
  }
}

export const trackingService = new TrackingService();
